import React from "react";
import { format } from "date-fns";
import { map } from "ramda";

import styled from "styles/styled_components";
import DayCell from "components/schedule/day_cell";
import PersonInfo from "components/schedule/person_info";

import PersonContext from "helpers/context/person";
import { DateFormats } from "helpers/dates";
import { IPerson } from "types/schedules";
import { ShiftsTotalHours } from "components/schedule/ShiftsTotalHours";

interface IStyledPersonRowProps {
  heavyBorder: boolean;
}

const StyledPersonRow = styled("tr")<IStyledPersonRowProps>`
  ${({ heavyBorder, theme }) =>
    heavyBorder && `border-bottom: 2px solid ${theme.colors.dsGrayLight};`}
  font-family: ${props => props.theme.text.primaryFamily};
  height: 1px;
  width: 100%;
`;

const StyledAssigneeCell = styled.td`
  border-bottom: ${props => props.theme.lightBorder};
  position: relative;
`;

interface IScheduleTablePersonRowProps {
  person: IPerson;
  scheduleDates: Date[];
  interactiveView: boolean;
}

function ScheduleTablePersonRow({
  person,
  scheduleDates,
  interactiveView,
}: IScheduleTablePersonRowProps) {
  const weekSchedule = map((date: Date) => {
    return (
      <DayCell
        key={format(date, DateFormats.YEAR_MONTH_DAY)}
        date={date}
        interactiveView={interactiveView}
      />
    );
  }, scheduleDates);

  return (
    <PersonContext.Provider value={person}>
      <StyledPersonRow heavyBorder={person.assignee.isNothing()}>
        <StyledAssigneeCell>
          <PersonInfo
            person={person}
            shiftsTotalHours={<ShiftsTotalHours shifts={person.shifts} />}
          />
        </StyledAssigneeCell>
        {weekSchedule}
      </StyledPersonRow>
    </PersonContext.Provider>
  );
}

export default ScheduleTablePersonRow;
